import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TranslateModule} from '../../translate-module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import {CompanyService} from '../../services/company.service';
import { AppDataService } from '../../services';
import { DepoimentosComponent } from './depoimentos.component';

@NgModule({
  declarations: [
DepoimentosComponent

  ],
  imports: [
    BrowserModule,
    HttpModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,

    BrowserModule.withServerTransition({
      appId: 'angular-universal-firebase'
    }),


  ],
  providers: [
    CompanyService,
    AppDataService


  ],
  exports: [
    DepoimentosComponent
    ]
})
export class DepoimentosModule { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/depoimentos/depoimentos.module.ts